// eslint-disable-next-line import/prefer-default-export
export enum PageLoaderStatus {
  LOADING = 0,
  READY = 1,
  ERROR = -1,
}
